import React, { ReactNode } from "react";

import { CenteredFormWrap } from "./CenteredForm.styles";
import PageWrap from "../PageWrap/PageWrap";

export const CenteredForm = ({ children }: { children: ReactNode }) => {
  return (
    <PageWrap>
      <CenteredFormWrap>
        <div className="inner-container">{children}</div>
      </CenteredFormWrap>
    </PageWrap>
  );
};
